import CN from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../../components/Button";
import { useSelector } from "react-redux";
import store from "../../store/store";
import { Oval } from "react-loader-spinner";
import { addUser } from "../Users/reducer/userSlice";

interface FormValues {
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phoneNumber: string;
  streetAddress: string;
  city: string;
  poBoxNumber: string;
  country: string;
  businessName: string;
  role: string;
}

export const AddUser: React.FC<any> = () => {
  const { isLoading } = useSelector((state: any) => state.rootReducer?.user);
  const navigate = useNavigate();

  // Validation schema
  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
    phoneNumber: Yup.string().required("Phone Number is required"),
    streetAddress: Yup.string().required("Street Address is required"),
    city: Yup.string().required("City is required"),
    poBoxNumber: Yup.number().required("PO Box Number is required"),
    country: Yup.string().required("Country is required"),
    businessName: Yup.string().required("Business Name is required"),
    role: Yup.string().required("Role is required"),
  });

  const { handleSubmit, handleChange, handleBlur, values, errors, touched } =
    useFormik<FormValues>({
      initialValues: {
        fullName: "",
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        phoneNumber: "",
        streetAddress: "",
        city: "",
        poBoxNumber: "",
        country: "",
        businessName: "",
        role: "",
      },
      validationSchema,
      onSubmit: (values: FormValues) => {
        store.dispatch(addUser(values));
      },
    });

  console.log("🚀 ~ values:", values);


  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <form onSubmit={handleSubmit}>
        <div className="lg:grid grid-cols-2 flex flex-col gap-6 my-4 py-8 lg:mx-8 mx-4">
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Full Name *
            </label>
            <input
              type="text"
              name="fullName"
              value={values.fullName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.fullName && touched.fullName
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.fullName && touched.fullName && (
              <p className="text-red-500 text-sm my-2">{errors.fullName}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              First Name *
            </label>
            <input
              type="text"
              name="firstName"
              value={values.firstName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.firstName && touched.firstName
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.firstName && touched.firstName && (
              <p className="text-red-500 text-sm my-2">{errors.firstName}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Last Name *
            </label>
            <input
              type="text"
              name="lastName"
              value={values.lastName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.lastName && touched.lastName
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.lastName && touched.lastName && (
              <p className="text-red-500 text-sm my-2">{errors.lastName}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Email *
            </label>
            <input
              type="email"
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.email && touched.email
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.email && touched.email && (
              <p className="text-red-500 text-sm my-2">{errors.email}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              Password *
            </label>
            <input
              type="password"
              name="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.password && touched.password
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.password && touched.password && (
              <p className="text-red-500 text-sm my-2">{errors.password}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              phone Number*
            </label>
            <input
              type="Number"
              name="phoneNumber"
              value={values.phoneNumber}
              onChange={(e) => handleChange({ 
                target: { name: "phoneNumber", value: e.target.value.toString() } 
              })}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.phoneNumber && touched.phoneNumber
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.phoneNumber && touched.phoneNumber && (
              <p className="text-red-500 text-sm my-2">{errors.phoneNumber}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              street Address*
            </label>
            <input
              type="text"
              name="streetAddress"
              value={values.streetAddress}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.streetAddress && touched.streetAddress
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.streetAddress && touched.streetAddress && (
              <p className="text-red-500 text-sm my-2">
                {errors.streetAddress}
              </p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">city *</label>
            <input
              type="text"
              name="city"
              value={values.city}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.city && touched.city
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.city && touched.city && (
              <p className="text-red-500 text-sm my-2">{errors.city}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              poBox Number *
            </label>
            <input
              type="Number"
              name="poBoxNumber"
              value={values.poBoxNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.poBoxNumber && touched.poBoxNumber
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.poBoxNumber && touched.poBoxNumber && (
              <p className="text-red-500 text-sm my-2">{errors.poBoxNumber}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              country *
            </label>
            <input
              type="text"
              name="country"
              value={values.country}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.country && touched.country
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.country && touched.country && (
              <p className="text-red-500 text-sm my-2">{errors.country}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">
              business Name *
            </label>
            <input
              type="text"
              name="businessName"
              value={values.businessName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.businessName && touched.businessName
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.businessName && touched.businessName && (
              <p className="text-red-500 text-sm my-2">{errors.businessName}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">Role *</label>
            <select
              name="role"
              value={values.role}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.role && touched.role
                  ? "border-red-500"
                  : "border-primary1"
              )}
            >
              <option value="" disabled>
                Select Role
              </option>
              <option value="customer">Customer</option>
              <option value="non-customer">Non-Customer</option>
            </select>
            {errors.role && touched.role && (
              <p className="text-red-500 text-sm my-2">{errors.role}</p>
            )}
          </div>
        </div>
        <div className="flex justify-end flex-row gap-4 mt-5 py-4 w-full sticky bottom-0 bg-primary2 lg:px-8 px-4">
          <Button
            onClick={() => navigate("/users")}
            apparence="gray"
            type="button"
          >
            Cancel
          </Button>
          <Button isLoading={isLoading.userAdd} view="default" type="submit">
            <div className="flex gap-1">
              {isLoading.userAdd && (
                <Oval
                  height={18}
                  width={18}
                  color="#ffff"
                  visible={true}
                  ariaLabel="oval-loading"
                  strokeWidth={6}
                />
              )}
              <div className="font-normal text-base">Save</div>
            </div>
          </Button>
        </div>
      </form>
    </motion.div>
  );
};

export default AddUser;


